function hasData(str?: string | null) {
  return !(typeof str !== "string" || !str || (str ?? "").length === 0 || (str ?? "").replaceAll(" ", "").length === 0);
}

function capitalize(str?: string) {
  if (!str) {
    return;
  }
  return str[0].toUpperCase() + str.substring(1);
}

function reverseCamelCase(str?: string) {
  if (!str) {
    return;
  }
  return str
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/\b([A-Z]+)([A-Z])([a-z])/, "$1 $2$3")
    .replace(/^./, function (str) {
      return str.toUpperCase();
    });
}

function checkIsStringOrIsNull(toCheck: any, isNull: string): string {
  return (typeof toCheck === "string" ? toCheck : undefined) ?? isNull;
}

function checkIsStringOrArrayAndIsNull(toCheck: any, isNull: string): string {
  if (Array.isArray(toCheck)) {
    if (toCheck.length > 0) {
      return `${toCheck[0]}`;
    }
  }
  return (typeof toCheck === "string" ? toCheck : undefined) ?? isNull;
}

function valueIsPluralBasedOnCount(str?: string, count?: number) {
  if (typeof count !== "number" || typeof str !== "string") {
    return str;
  }
  return count === 1 ? str : `${str}s`;
}

function getNestedValue(obj: any, path: string): any {
  return path.split(".").reduce((acc, part) => acc?.[part], obj);
}

function replaceValues<D>(template: string, data: D): string {
  if (!template) {
    return "";
  }
  return template.replace(/\$\{(.*?)\}/g, (_, key) => {
    const trimmedKey = key.trim();
    return getNestedValue(data, trimmedKey)?.toString() || "";
  });
}

export function addCommasToNumber(value: string, locale: string = "en-US"): string {
  const num = Number(value);
  if (isNaN(num)) {
    return value;
  }
  return Math.floor(num).toLocaleString(locale);
}

function stringToArray(str: string): Array<string> {
  // Remove square brackets if they exist
  const trimmedStr = str.trim().replace(/^\[|\]$/g, "");

  if (!trimmedStr) {
    return [];
  }

  return trimmedStr
    .split(",")
    .map((item) => item.trim())
    .filter((item) => item.length > 0);
}

export default {
  checkIsStringOrIsNull,
  reverseCamelCase,
  capitalize,
  hasData,
  checkIsStringOrArrayAndIsNull,
  valueIsPluralBasedOnCount,
  getNestedValue,
  replaceValues,
  addCommasToNumber,
  stringToArray,
};
